import script from "./FoodView.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodView.vue?vue&type=script&setup=true&lang=js"

import "./FoodView.vue?vue&type=style&index=0&id=d794ba9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d794ba9c"]])

export default __exports__